import React from "react";
import { Link } from "react-router-dom";
import { MEMBERSHIP_CONFIG } from "../../data/membershipData";
import { track, EVENTS } from "../../utils/analytics";

/**
 * Homepage VIP+ promo band (Growth Platform — Strategy #01).
 *
 * A compact teaser that surfaces the membership on the homepage and drives to
 * the full /vip page. Reads pricing/benefits from membershipData.js — no
 * hard-coded numbers. Shows a few highlight benefits, not the full list.
 */

const NAVY = "#18305d";
const ACCENT = "#ffaa19";

const { program, plans, benefits } = MEMBERSHIP_CONFIG;

// Highlight the first four benefits on the homepage teaser.
const HIGHLIGHTS = benefits.slice(0, 4);

function VipPromoBand() {
  const monthly = plans.find((p) => p.interval === "month") || plans[0];
  const yearly = plans.find((p) => p.interval === "year");

  return (
    <section className="section" style={{ padding: "60px 0" }}>
      <div className="container">
        <div
          style={{
            background:
              "linear-gradient(135deg, #0b1e3f 0%, #18305d 55%, #103f79 100%)",
            borderRadius: "20px",
            padding: "44px 40px",
            boxShadow: "0 18px 50px rgba(11,24,48,0.28)",
            overflow: "hidden",
          }}
        >
          <div className="row align-items-center">
            {/* Copy + benefits */}
            <div className="col-lg-7 mb-4 mb-lg-0">
              <span
                style={{
                  display: "inline-block",
                  background: "rgba(255,170,25,0.15)",
                  color: ACCENT,
                  fontWeight: 800,
                  letterSpacing: ".08em",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  padding: "6px 13px",
                  borderRadius: "999px",
                  marginBottom: "14px",
                }}
              >
                <i className="fas fa-crown mr-2" />
                {program.name} Membership
              </span>
              <h3 style={{ color: "#fff", fontSize: "30px", marginBottom: "12px" }}>
                Stop paying full price. Start being a member.
              </h3>
              <p style={{ color: "rgba(255,255,255,0.82)", marginBottom: "22px" }}>
                Join {program.name} and unlock member pricing, free monthly
                perks, and priority service.
              </p>
              <div className="row">
                {HIGHLIGHTS.map((b) => (
                  <div className="col-sm-6 mb-15" key={b.text}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className={b.icon} style={{ color: ACCENT, width: "18px" }} />
                      <span style={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}>
                        {b.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Price + CTA */}
            <div className="col-lg-5 text-center text-lg-right">
              <div
                style={{
                  display: "inline-block",
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "26px 34px",
                }}
              >
                <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: "6px" }}>
                  <span style={{ fontSize: "42px", fontWeight: 800, color: NAVY }}>
                    ${monthly.price}
                  </span>
                  <span style={{ color: "#657089", fontWeight: 600 }}>
                    {monthly.priceSuffix}
                  </span>
                </div>
                {yearly && (
                  <p style={{ margin: "4px 0 18px", color: "#657089", fontSize: "13px" }}>
                    or ${yearly.price}
                    {yearly.priceSuffix} — best value
                  </p>
                )}
                <Link
                  to="/vip"
                  className="btn btn-primary"
                  style={{ padding: "13px 30px" }}
                  onClick={() =>
                    track(EVENTS.MEMBERSHIP_VIEWED, { source: "home_promo_band" })
                  }
                >
                  <i className="fas fa-crown mr-2" />
                  Explore {program.name}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VipPromoBand;
